export default function DSA_Home() {
  return <div>DSA_Home Component</div>;
}
